import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DropdownComponent } from '@app/components/dropdowns/dropdown';
import { MainNavigationComponent } from '@app/components/main-navigation';
import { ToastComponent } from '@app/components/toast';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TopbarComponent } from '../../topbar/topbar.component';
import { NAVIGATION_LINKS } from './feature-layout.paths';

@Component({
  standalone: true,
  selector: 'app-feature-layout',
  templateUrl: './feature-layout.component.html',
  styleUrl: './feature-layout.component.css',
  imports: [
    CommonModule,
    RouterModule,
    MainNavigationComponent,
    ToastComponent,
    DropdownComponent,
    TranslatePipe,
    TranslateDirective,
    TopbarComponent,
  ],
})
export class FeatureLayoutComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly route = inject(ActivatedRoute);
  private readonly adminTenantService = inject(AdminTenantService);
  links = NAVIGATION_LINKS.filter(
    (link) =>
      !link.hiddenForSsoOAuth || !this.adminTenantService.isSsoOAuthTenant()
  );
  user = {
    name: '',
    roles: undefined,
  };

  ngOnInit(): void {
    this.route.data
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        const { user } = data.initialData;
        this.user.name =
          user.name || `${user.firstName ?? ''} ${user.lastName ?? ''}`;
        this.user.roles = user.roles;
      });
  }
}
